module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/what-is-vux-virtual-component-24.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/what-is-vux-virtual-component.md
// module id = 594
// module chunks = 198